import { render, staticRenderFns } from "./AccountAdditionalDetailsTable.vue?vue&type=template&id=216c5e26&"
import script from "./AccountAdditionalDetailsTable.vue?vue&type=script&lang=js&"
export * from "./AccountAdditionalDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports